import {ValueObject} from '@s-ui/domain'

export class BodyTypesListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */
}
